import { useMediaQuery } from '@mui/material'
import styles from './TargetPlus.module.scss'

const TargetPlus = (props) => {
  const isDesktopView = useMediaQuery('(min-width: 900px)')
  return (
    <>
      {isDesktopView ? (
        <svg
          className={styles.targetPlusSvg}
          width="71"
          height="42"
          viewBox="0 0 71 42"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6357_978)">
            <path
              d="M42.1245 21C42.1245 32.5986 32.6953 42 21.0623 42C9.42927 42 0 32.5986 0 21C0 9.40139 9.42927 0 21.0623 0C32.6953 0 42.1245 9.40139 42.1245 21ZM21.0623 7.00444C13.3025 7.00444 7.02521 13.2765 7.02521 21C7.02521 28.7235 13.3158 34.9956 21.0623 34.9956C28.8087 34.9956 35.0993 28.7235 35.0993 21C35.0993 13.2765 28.8087 7.00444 21.0623 7.00444Z"
              fill="#CB2026"
            />
            <path
              d="M21.0623 13.9956C17.1891 13.9956 14.0371 17.1249 14.0371 21C14.0371 24.8751 17.1757 28.0044 21.0623 28.0044C24.9489 28.0044 28.0875 24.8751 28.0875 21C28.0875 17.1249 24.9489 13.9956 21.0623 13.9956Z"
              fill="#CB2026"
            />
            <path
              d="M61.7577 18.1503V8.93532H56.0281V18.1503H46.7858V23.863H56.0281V33.078H61.7577V23.863H71V18.1503H61.7577Z"
              fill="white"
            />
            <path
              d="M68.2487 31.6665H67.7278V31.4268H69.05V31.6665H68.5291V33.0514H68.2487V31.6665Z"
              fill="white"
            />
            <path
              d="M69.2371 31.4268H69.6377L70.0918 32.7051L70.5326 31.4268H70.9333V33.0514H70.6661V31.7996L70.212 33.0514H69.9716L69.5175 31.7996H69.5042V33.0514H69.2371V31.4268Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_6357_978">
              <rect width="71" height="42" fill="white" />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          className={styles.targetPlusSvg}
          width="61"
          height="36"
          viewBox="0 0 61 36"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6340_924)">
            <path
              d="M36.1915 18C36.1915 27.9417 28.0903 36 18.0957 36C8.1012 36 0 27.9417 0 18C0 8.05834 8.1012 0 18.0957 0C28.0903 0 36.1915 8.05834 36.1915 18ZM18.0957 6.0038C11.4289 6.0038 6.03574 11.3798 6.03574 18C6.03574 24.6202 11.4404 29.9962 18.0957 29.9962C24.7511 29.9962 30.1558 24.6202 30.1558 18C30.1558 11.3798 24.7511 6.0038 18.0957 6.0038Z"
              fill="#CB2026"
            />
            <path
              d="M18.0957 11.9962C14.7681 11.9962 12.06 14.6785 12.06 18C12.06 21.3215 14.7566 24.0038 18.0957 24.0038C21.4349 24.0038 24.1315 21.3215 24.1315 18C24.1315 14.6785 21.4349 11.9962 18.0957 11.9962Z"
              fill="#CB2026"
            />
            <path
              d="M53.0594 15.5574V7.65885H48.1368V15.5574H40.1962V20.454H48.1368V28.3526H53.0594V20.454H61V15.5574H53.0594Z"
              fill="white"
            />
            <path
              d="M58.6362 27.1427H58.1887V26.9372H59.3247V27.1427H58.8772V28.3297H58.6362V27.1427Z"
              fill="white"
            />
            <path
              d="M59.4853 26.9372H59.8296L60.2197 28.033L60.5984 26.9372H60.9426V28.3297H60.7131V27.2568L60.323 28.3297H60.1164L59.7263 27.2568H59.7148V28.3297H59.4853V26.9372Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_6340_924">
              <rect width="61" height="36" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  )
}

export default TargetPlus
